import { defineStore } from 'pinia'

type State = {
  title: string,
  sidebarData: SidebarData,
}

const APP_TITLE = import.meta.env.VITE_APP_TITLE ?? ''

export const usePageStore = defineStore('Page', {
  state: (): State => ({
    title: '',
    sidebarData: {
      move_order_count: {
        send: 0,
        receive: 0,
      },
    },
  }),
  actions: {
    setPageTitle (title: string) {
      this.title = title
      document.title = `${title} | ${APP_TITLE}`
    },
    setSidebarData (data: SidebarData) {
      this.sidebarData = data
    },
  },
})
